export function getLinkAriaLabel({
  children,
  target,
  ariaLabel,
  href,
}: {
  children?: React.ReactNode;
  target?: string;
  ariaLabel?: string;
  href?: string;
}): string | undefined {
  const isStringChild = typeof children === 'string';
  const baseLabel = ariaLabel || (isStringChild ? children : href);
  const opensInNewTab = target === '_blank' ? ', opens in a new tab' : '';

  return baseLabel ? `${baseLabel}${opensInNewTab}` : undefined;
}

export default getLinkAriaLabel;
